import { StepType } from "@redotech/redo-flows-core-schema-common/common";
import { assertNever } from "@redotech/util/type";
import { PartialFlowStep } from "../steps";

export function getOutgoingStepIds(step: PartialFlowStep): string[] {
  const stepIds: string[] = [];

  const addStepId = (stepId: string | null | undefined) => {
    if (stepId) {
      stepIds.push(stepId);
    }
  };

  const addNextId = () => {
    if ("nextId" in step) {
      addStepId(step.nextId);
    }
  };
  const addConditionIds = () => {
    if ("nextTrueId" in step) {
      addStepId(step.nextTrueId);
    }
    if ("nextFalseId" in step) {
      addStepId(step.nextFalseId);
    }
  };
  const addSegmentIds = () => {
    if ("matchingNextId" in step) {
      addStepId(step.matchingNextId);
    }
    if ("nonMatchingNextId" in step) {
      addStepId(step.nonMatchingNextId);
    }
  };
  const addPostPurchasePageIds = () => {
    if ("acceptNextId" in step) {
      addStepId(step.acceptNextId);
    }
    if ("declineNextId" in step) {
      addStepId(step.declineNextId);
    }
  };
  const addVariantIds = () => {
    if ("variants" in step && Array.isArray(step.variants)) {
      for (const variant of step.variants) {
        addStepId(variant?.nextId);
      }
    }
  };
  const addTreatmentIds = () => {
    if ("treatments" in step && Array.isArray(step.treatments)) {
      for (const treatment of step.treatments) {
        addStepId(treatment?.nextId);
      }
    }
  };
  const addNaryEdgeIds = () => {
    if ("edges" in step && Array.isArray(step.edges)) {
      for (const edge of step.edges) {
        addStepId(edge?.nextId);
      }
    }
  };

  switch (step.type) {
    case StepType.TRIGGER:
    case StepType.WAIT:
    case StepType.WAIT_FOR_EVENT:
    case StepType.SEND_EMAIL:
    case StepType.SEND_SMS:
    case StepType.RECOGNIZE_EMAIL:
    case StepType.SEND_WEBHOOK:
    case StepType.MANAGE_CUSTOMER_TAGS:
    case StepType.MANAGE_STATIC_SEGMENT:
    case StepType.RECOVER:
    case StepType.OMS_ACTION:
    case StepType.OMS_CODE:
    case StepType.UPSELL:
    case StepType.DOWNSELL:
    case StepType.TRACKING_PAGE:
    case StepType.WORK_ORDER_WORK_STEP:
    case StepType.RULE_ACTIONS:
    case StepType.RULE_ACTIONS_V3:
    case StepType.PROCESS_RETURN:
    case StepType.COMPENSATION_STEP:
    case StepType.RESTOCKING_STEP:
    case StepType.CONCIERGE_BLOCK:
    case StepType.SHOPPER_AGENT_MESSAGE:
    case StepType.CHECKOUT_EXPERIENCE:
      addNextId();
      break;
    case StepType.CONDITION:
    case StepType.OMS_CONDITION:
    case StepType.UPSELL_CONDITION:
    case StepType.RCO_CHECKOUT_PACKAGE_CONDITION:
    case StepType.RULE_CONDITIONS:
    case StepType.RULE_CONDITIONS_V3:
    case StepType.WORK_ORDER_CONDITION:
    case StepType.RETURN_FLOW_CONDITION:
      addConditionIds();
      break;
    case StepType.AB_TEST:
      addVariantIds();
      break;
    case StepType.RCO_SPLIT:
    case StepType.POST_PURCHASE_SPLIT:
      addTreatmentIds();
      break;
    case StepType.RCO_SEGMENT:
      addSegmentIds();
      addNaryEdgeIds();
      break;
    case StepType.POST_PURCHASE_SEGMENT:
      addSegmentIds();
      break;
    case StepType.POST_PURCHASE_PAGE:
      addPostPurchasePageIds();
      break;
    case StepType.HSA_QUESTION_GROUP:
    case StepType.HSA_CONTENT:
      addNextId();
      break;
    case StepType.HSA_CONDITION:
    case StepType.SUPPLIES_SHIPPING_CONDITION:
      addSegmentIds();
      break;
    case StepType.RCO_CHECKOUT_PACKAGE:
    case StepType.BLOCK_CHECKOUT:
    case StepType.DO_NOTHING:
    case StepType.HSA_END:
    case StepType.HSA_KNOCKOUT:
    case StepType.SUPPLIES_SHIPPING_RATE:
      break;
    default:
      assertNever(step);
  }

  return stepIds;
}
